/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  export class AnchorNavItem {
    constructor(
      public key: string,
      public element: HTMLElement,
      public top: number,
      public bottom: number,
      public isActive?: () => boolean,
      public useInScrollNav? : boolean,
      public title? : string
      ) { 
    
    }

    public compareKey(key : string) : boolean {
      if (!key || !this.key) return false;
      return this.key.toLowerCase() === key.toLowerCase();
    }
    
    public isAtStartOf(key : string) : boolean {
      if (!key || !this.key) return false;
      return key.toLowerCase().indexOf(this.key.toLowerCase()) == 0;
    }
    
    public compareQuery(query : { [key: string]: any; }, partialMatch? : boolean) : boolean {
      if (!query || !this.key) return false;
      var result = false;
      var myKey = this.key.replace("?", "").toLowerCase();
      for (var key in query) {
        if (key.toLowerCase() === myKey) return query[key];
        if (partialMatch && key.toLowerCase().indexOf(myKey) == 0) return query[key];
      }
      return false;
    }

  }
}